import { AsyncPipe, NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnInit,
  Output,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { PersonalDetailsFormValue } from '@checkout/util-models';
import { CmsBrandPrivacyPolicyPipe } from '@domgen/dgx-fe-cms';
import {
  InterpolatePipe,
  TestHookDirective,
} from '@domgen/dgx-fe-components/general';
import {
  OverrideAddressComponent,
  provideFormsAddressDefaults,
} from '@domgen/dgx-fe-forms/address';
import {
  EmailInputComponent,
  TelephoneInputComponent,
  TextInputComponent,
} from '@domgen/dgx-fe-forms/input';
import {
  FormFieldComponent,
  FormFieldDirective,
  FormFieldsetComponent,
  FormFieldsetDirective,
  FormRowComponent,
  FormSubmitButtonComponent,
} from '@domgen/dgx-fe-forms/layout';
import { RadioButtonComponent } from '@domgen/dgx-fe-forms/radio';
import { SelectComponent } from '@domgen/dgx-fe-forms/select';
import { FormSubmitDirective } from '@domgen/dgx-fe-forms/shared';
import {
  GAClickDirective,
  GAContainerDirective,
  GAFormFieldDirective,
  GAFormSubmitDirective,
} from '@domgen/dgx-fe-ga';
import { TranslatePipe } from '@domgen/dgx-fe-i18n';
import { QMSanitiseDirective } from '@domgen/dgx-fe-qm';
import { PersonalDetailsTestHooks } from '../../models/test/personal-details-test-hooks.enum';
import { providePersonalDetailsI18n } from '../../providers/personal-details-i18n.provider';
import { PersonalDetailsFormBuilder } from '../../services/personal-details-form-builder/personal-details-form-builder.service';
import { PersonalDetailsFormComponentService } from '../../services/personal-details-form-component/personal-details-form-component.service';

@Component({
  selector: 'checkout-personal-details-form',
  templateUrl: './personal-details-form.component.html',
  styleUrls: ['./personal-details-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    AsyncPipe,
    CmsBrandPrivacyPolicyPipe,
    EmailInputComponent,
    FormFieldComponent,
    FormFieldDirective,
    FormFieldsetComponent,
    FormFieldsetDirective,
    FormRowComponent,
    FormSubmitButtonComponent,
    FormSubmitDirective,
    GAClickDirective,
    GAContainerDirective,
    GAFormFieldDirective,
    GAFormSubmitDirective,
    InterpolatePipe,
    NgIf,
    OverrideAddressComponent,
    QMSanitiseDirective,
    RadioButtonComponent,
    ReactiveFormsModule,
    SelectComponent,
    TelephoneInputComponent,
    TestHookDirective,
    TextInputComponent,
    TranslatePipe,
  ],
  providers: [
    PersonalDetailsFormBuilder,
    PersonalDetailsFormComponentService,
    provideFormsAddressDefaults(),
    providePersonalDetailsI18n(),
  ],
})
export class PersonalDetailsFormComponent implements OnInit {
  @Output() submitted = new EventEmitter<PersonalDetailsFormValue>();

  testHooks = PersonalDetailsTestHooks;

  constructor(readonly cs: PersonalDetailsFormComponentService) {}

  ngOnInit(): void {
    this.cs.buildForm();
  }

  onFormSubmit(formValue: PersonalDetailsFormValue): void {
    this.submitted.emit(formValue);
  }
}
